import { useEffect, useState } from "react";
import { getFormData, getQueryData, getQueryString } from '../../../common';
import { searchComplexAreaV4, searchFrontYards, searchLivingAreas } from '../../../repository/RealEstateRepository';
import { BreadCrumb, Navbar } from '../molecule';
import { ComplexAreaList, ComplexAreaPriceTable, FrontYardLivingAreaFormOnly } from '../organism';

const ComplexAreaListPage = (props) => {
    const [onload, setOnload] = useState(false);

    const [complexAreas, setComplexAreas] = useState([]);
    const [frontYards, setFrontYards] = useState([]);
    const [livingAreas, setLivingAreas] = useState([]);

    const [selectedFrontYardId, setSelectedFrontYardId] = useState(0);
    const [selectedLivingAreaId, setSelectedLivingAreaId] = useState(0);
    const [selectedArea, setSelectedArea] = useState(0);
    const [selectedAge, setSelectedAge] = useState("");

    const [selectedViewType, setSelectedViewType] = useState("LIST"); // LIST,PRICE

    const getLinks = () => [
        {
            title: "Home",
            to: "/realestate"
        },
        {
            title: "ComplexArea",
        }
    ];

    useEffect(() => {
        searchFrontYards({}, (res) => setFrontYards(res.content));
    }, []);

    useEffect(() => {
        const { frontYardId, livingAreaId, area, age } = getQueryData(props.location.search);
        fetchGetLivingAreas({ frontYardId });
        frontYardId && setSelectedFrontYardId(frontYardId);
        livingAreaId && setSelectedLivingAreaId(livingAreaId);
        // initialize
        area && setSelectedArea(area);
        age && setSelectedAge(age);
        frontYardId && fetchComplexAreas({ frontYardId, livingAreaId, generalExclusiveArea: area, age });
        // onLoad
        setOnload(true);
    }, [props.location]);

    const fetchGetLivingAreas = (request) => {
        if (!request.frontYardId) {
            setLivingAreas([]);
        } else {
            searchLivingAreas(request, (res) => setLivingAreas(res.content));
        }
    };

    const onChangeArea = (e) => {
        const formData = getFormData(e.target.form);
        !formData.frontYardId && delete formData.frontYardId;
        !formData.livingAreaId && delete formData.livingAreaId;
        !formData.area && delete formData.area;
        !formData.age && delete formData.age;
        props.history.push(`?${getQueryString(formData)}`);
    };

    const onChangeAge = (e) => {
        const formData = getFormData(e.target.form);
        !formData.frontYardId && delete formData.frontYardId;
        !formData.livingAreaId && delete formData.livingAreaId;
        !formData.area && delete formData.area;
        !formData.age && delete formData.age;
        props.history.push(`?${getQueryString(formData)}`);
    };

    const fetchComplexAreas = (request) => {
        searchComplexAreaV4(request, (res) => setComplexAreas(res.content));
    };

    const refresh = () => {
        const formData = { frontYardId: selectedFrontYardId, livingAreaId: selectedLivingAreaId, generalExclusiveArea: selectedArea, age: selectedAge };
        !formData.frontYardId && delete formData.frontYardId;
        !formData.livingAreaId && delete formData.livingAreaId;
        !formData.generalExclusiveArea && delete formData.generalExclusiveArea;
        !formData.age && delete formData.age;
        fetchComplexAreas(formData);
    };

    const onChangeView = (viewType) => {
        setSelectedViewType(viewType);
    };

    return onload && (<>
        <Navbar pathname={props.location.pathname} />
        <div style={{ height: 56 + 16 }} />

        <div className="container-fluid">
            <BreadCrumb links={getLinks()} />

            <form className="row">
                <FrontYardLivingAreaFormOnly
                    frontYards={frontYards}
                    livingAreas={livingAreas}
                    selectedFrontYardId={selectedFrontYardId}
                    selectedLivingAreaId={selectedLivingAreaId}
                    onChangeFrontYard={(e) => {
                        props.history.push(`?${getQueryString(getFormData(e.target.form))}`);
                    }}
                    onChangeLivingArea={(e) => {
                        props.history.push(`?${getQueryString(getFormData(e.target.form))}`);
                    }} />

                <div className={"col-6 col-sm-4 col-md-3 col-lg-2 text-left"}>
                    <select name={"area"} onChange={onChangeArea} className={"form-control form-control-sm"} defaultValue={selectedArea}>
                        <option value={0}>면적</option>
                        <option value={59}>전용59</option>
                        <option value={74}>전용74</option>
                        <option value={84}>전용84</option>
                    </select>
                </div>

                <div className={"col-6 col-sm-4 col-md-3 col-lg-2 text-left"}>
                    <select name={"age"} onChange={onChangeAge} className={"form-control form-control-sm"} defaultValue={selectedAge}>
                        <option value={""}>연식</option>
                        <option value={"NEW"}>신축</option>
                        <option value={"SEMI_NEW"}>준신축</option>
                        <option value={"OLD"}>구축</option>
                    </select>
                </div>
            </form>
            <br />

            <div className="row">
                <div className="col-2 btn-group" style={{ textAlign: "left" }}>
                    <button onClick={(e) => onChangeView("LIST")} className={"btn btn-sm " + (selectedViewType === "LIST" ? "btn-secondary" : "btn-outline-secondary")}>목록</button>
                    <button onClick={(e) => onChangeView("PRICE")} className={"btn btn-sm " + (selectedViewType === "PRICE" ? "btn-secondary" : "btn-outline-secondary")}>금액</button>
                </div>
            </div>
            <div style={{ paddingTop: 10 }} />
            {selectedViewType === "LIST" && <ComplexAreaList content={complexAreas} refresh={refresh} />}
            {selectedViewType === "PRICE" && <ComplexAreaPriceTable content={complexAreas} />}
        </div>
    </>);
}

export { ComplexAreaListPage };
